module.exports = __webpack_public_path__ + "static/lafayette.1d68c6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/lafayette.png
// module id = 2186
// module chunks = 61762850755587